import { render, staticRenderFns } from "./sfqx.vue?vue&type=template&id=2b982cba&scoped=true&"
import script from "./sfqx.vue?vue&type=script&lang=js&"
export * from "./sfqx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b982cba",
  null
  
)

export default component.exports